export default "__VITE_ASSET__Z86n3Rh1__"